import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54598d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ee-dashboard container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  id: "filters",
  class: "row mt-2"
}
const _hoisted_5 = {
  key: 0,
  class: "col-4 ml-0"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "field_name mb-1" }, "Compliance year", -1))
const _hoisted_7 = {
  key: 1,
  class: "col-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "field_name mb-1" }, "Progress", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_10 = {
  key: 2,
  style: {"margin-top":"1.75rem"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_12 = {
  key: 1,
  id: "practice-cards"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No records.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx, _cache) {
  const _component_MultiSelectFilterYears = _resolveComponent("MultiSelectFilterYears")
  const _component_MultiSelectFilterStatus = _resolveComponent("MultiSelectFilterStatus")
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_PracticeCard = _resolveComponent("PracticeCard")
  const _component_HelpScreen = _resolveComponent("HelpScreen")
  const _component_UpdateEEModal = _resolveComponent("UpdateEEModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.helpContent?.isShow)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-outline sml",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.showHelpScreen = !_ctx.showHelpScreen))
          }, "Help"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.yearsList.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_MultiSelectFilterYears, {
              yearsList: _ctx.yearsList,
              "onUpdate:yearsList": _cache[1] || (_cache[1] = $event => ((_ctx.yearsList) = $event)),
              onSelectYears: _ctx.selectYears
            }, null, 8, ["yearsList", "onSelectYears"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.statusList.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_MultiSelectFilterStatus, {
              statusList: _ctx.statusList,
              "onUpdate:statusList": _cache[2] || (_cache[2] = $event => ((_ctx.statusList) = $event)),
              onSelectStatus: _ctx.selectStatus
            }, null, 8, ["statusList", "onSelectStatus"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_9,
      (!_ctx.isLoadingData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.updateEE()))
            }, "Update External Examiner details")
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_11,
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (_ctx.practices.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practices, (practice, index) => {
              return (_openBlock(), _createBlock(_component_PracticeCard, {
                key: practice.id,
                practice: practice,
                modelValue: _ctx.practices[index],
                "onUpdate:modelValue": $event => ((_ctx.practices[index]) = $event),
                dashboardType: _ctx.dashboardType
              }, null, 8, ["practice", "modelValue", "onUpdate:modelValue", "dashboardType"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
    (_ctx.showHelpScreen)
      ? (_openBlock(), _createBlock(_component_HelpScreen, {
          key: 3,
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.showHelpScreen = false)),
          helpContent: _ctx.helpContent
        }, {
          header: _withCtx(() => [
            _hoisted_16
          ]),
          body: _withCtx(() => []),
          _: 1
        }, 8, ["helpContent"]))
      : _createCommentVNode("", true),
    (_ctx.showUpdateEEmodal)
      ? (_openBlock(), _createBlock(_component_UpdateEEModal, {
          key: 4,
          onClose: _cache[5] || (_cache[5] = $event => (_ctx.showUpdateEEmodal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}